// extracted by mini-css-extract-plugin
module.exports = {"Body":"ComingSoon_Body__3SsQM","Loader":"ComingSoon_Loader__3w_bS"};